export const LANGUAGES = {
    en: 'en',
    es: 'es'
};
